export default __webpack_public_path__ + "static/media/copy.49a51ed2.svg";